export function fromPersistent(media: {
    id: string | number;
    name: string | null;
    user_id: string | number | null;
    asset_id: string | number | null;
    asset_type: string | null;
    kind_type: string | null;
    sku: string | null;
    fmt: string | null;
    materials: Record<string, unknown>[] | null;
    width: number | null;
    height: number | null;
    result: {
        host: string;
        resolutions: {width: number; height: number}[];
        views: Record<string, {path: string | null}>;
    } | null;
    state: string | null;
    deleted_at: string | null;
    created_at: string | null;
    updated_at: string | null;
    settings: {
        fmt?: string | null;
        shadows?: boolean;
        background?: string | null;
    } | null;
}) {
    const views = getViewItems(media);
    const [firstView] = views;
    const {
        id,
        name,
        user_id,
        asset_id,
        asset_type,
        kind_type,
        sku,
        fmt,
        materials,
        width,
        height,
        result,
        state,
        deleted_at,
        created_at,
        updated_at,
        settings,
    } = media;

    return {
        id,
        name,
        userId: user_id,
        assetId: asset_id,
        assetType: asset_type,
        kind: kind_type,
        sku,
        fmt,
        materials,
        views,
        width,
        height,
        state,
        result,
        image: firstView?.image ?? null,
        thumbnail: firstView?.thumbnail ?? null,
        deletedAt: deleted_at && new Date(deleted_at),
        createdAt: created_at && new Date(created_at),
        updatedAt: updated_at && new Date(updated_at),
        settings: {
            fmt: settings?.fmt ?? null,
            shadows: settings?.shadows ?? false,
            background: settings?.background ?? null,
            width: width ?? null,
            height: height ?? null,
            materials: materials ?? null,
        },
    };
}

function getViewItems(media: {
    id: string | number;
    fmt: string | null;
    result: {
        host: string;
        resolutions: {width: number; height: number}[];
        views: Record<string, {path: string | null}>;
    } | null;
    kind_type: string | null;
    kind?: string | null;
    views?: string[] | undefined;
}) {
    const {id, fmt, result, kind_type, kind = kind_type, views = []} = media;

    if (result) {
        const {host, resolutions} = result;
        const [hq] = resolutions;
        const lq = resolutions[resolutions.length - 1];

        return views.map((view: string) => {
            const path = result.views[view].path ?? null;
            const filename =
                kind === 'Products::Lifestyle'
                    ? `${id}`
                    : kind === 'Products::Spin360'
                      ? `${id}_${view}.0001`
                      : `${id}_${view}`;

            return {
                view,
                image: `${host}/${path}/${hq.width}x${hq.height}/${filename}.${fmt}`,
                thumbnail: `${host}/${path}/${lq.width}x${lq.height}/${filename}.${fmt}`,
            };
        });
    }

    return views.map((view: string) => ({view, image: null, thumbnail: null}));
}
